import { render } from "./SentencesMiniGuide.vue?vue&type=template&id=0d91ceb7"
import script from "./SentencesMiniGuide.vue?vue&type=script&lang=js"
export * from "./SentencesMiniGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__